/**
 * 미스터리(?) 블록 도메인 부트 — 일일 보상(다이아·유물) 자정 리셋만 기여(전용 탭/api 없음).
 *
 * 미스터리 블록은 전투 필드에 스폰되고 보상 지급은 BattlefieldRunner(grantMysteryReward)가 담당한다.
 * 여기서는 자정 리셋 등록 1줄만 — 리셋 시 MysteryBlockController.applyReset()이 두 카운터(다이아·유물)를
 * 0으로 되돌린다(던전 도전권·모듈 융합 리셋과 동형). 신규 일일 리셋 = boot 1파일 + bootSequence 1줄.
 */
import { DAILY_RESET_KEY_MYSTERY } from "../models/ModuleBrickSaveData.js";
import type { DomainBootstrapper } from "./BootTypes.js";

export const mysteryBoot: DomainBootstrapper = {
  key: "mystery",
  install(boot) {
    boot.dailyResets.register(DAILY_RESET_KEY_MYSTERY, () => boot.ctx.mysteryBlock().applyReset());
  },
};
